export const PREDEFINED_QUESTION_IDS: string[] = [
    'intl-msg:chatbot.predefinedQuestion.mdmContacts',
    'intl-msg:chatbot.predefinedQuestion.loginTrouble',
    'intl-msg:chatbot.predefinedQuestion.frontendAccess',
    'intl-msg:chatbot.predefinedQuestion.requestLogs',
    'intl-msg:chatbot.predefinedQuestion.deviceInfo',
];
